import { InjectionToken } from '@angular/core';
import { ContactFacadeService } from './contact.facade.service';

export { ContactFacadeService } from './contact.facade.service';

export const CONTACT_FACADE_SERVICE = new InjectionToken<ContactFacadeService>(
  'ContactFacadeService',
);
